import moment from 'moment';

export const diaDaSemana = (data) => {
  switch (moment(data).day()) {
    case 0:
      return 'domingo';
    case 1:
      return 'segunda-feira';
    case 2:
      return 'terça-feira';
    case 3:
      return 'quarta-feira';
    case 4:
      return 'quinta-feira';
    case 5:
      return 'sexta-feira';
    default:
      return 'sábado';
  }
};

export const formatDate = (isoString) => {
  return moment(isoString)
    .utc()
    .format('DD/MM/YYYY');
};
